import type { Options } from '@/scopes/common/components/Filters/Shared'
import { SpaceBetween, tk } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { RadioButton, RadioButtonGroup } from '@sunwebgroup/ui-components/uds/index'
import * as React from 'react'
import styled from 'styled-components'

const Content = styled.div`
  @media ${tk('mq_tablet')} {
    padding: ${tk('spacing_lg')};
  }
`

export function Root({ options, selectedOption, onSelectedValueChange, disabled }: {
  options: Options[]
  selectedOption: string | undefined
  onSelectedValueChange: (selection: string) => void
  disabled?: boolean

}) {
  return (
    <Content>
      <RadioButtonGroup
        onValueChange={onSelectedValueChange}
        value={selectedOption}
        defaultValue={selectedOption}
        disabled={disabled}
      >
        <SpaceBetween direction="y" spacing={tk('spacing_md')}>
          {options.map(({ name, value }) => (
            <SpaceBetween direction="x" key={value} spacing={tk('spacing_md')}>
              <RadioButton value={value} />
              <Typography $variant="body-m-regular-tight">{name}</Typography>
            </SpaceBetween>
          ))}
        </SpaceBetween>
      </RadioButtonGroup>
    </Content>
  )
}
